"use client";

import { useEffect, useState } from "react";
import { captureLandingUtm, getStoredLandingUtm } from "~/lib/utm";

const FORM_ID = "262667017677064";
const FORM_URL = `https://form.jotform.com/${FORM_ID}`;

// Jotform's published embed is a script that writes the form into the page at
// load time, which React doesn't own. A plain iframe is the same form without
// that. The form's hidden `utm_*` fields prefill from the iframe's query
// string, which is how a submission carries the QR variant that brought it.
export function JotformEmbed() {
  const [src, setSrc] = useState<string | null>(null);
  const [height, setHeight] = useState(720);

  useEffect(() => {
    // Capture here too: AttributionCapture is a parent, so its effect runs
    // after this one and the store would still be empty on the landing render.
    captureLandingUtm(new URLSearchParams(window.location.search));
    const utm = getStoredLandingUtm();
    setSrc(utm ? `${FORM_URL}?${utm}` : FORM_URL);

    // The form posts "setHeight:<px>:<formId>" as its content grows.
    const onMessage = (e: MessageEvent) => {
      if (!e.origin.endsWith("jotform.com") || typeof e.data !== "string")
        return;
      const [action, px, id] = e.data.split(":");
      if (action === "setHeight" && id === FORM_ID && Number(px) > 0)
        setHeight(Number(px));
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  return (
    <div style={{ height }} className="w-full">
      {src && (
        <iframe
          title="Fleet Week giveaway entry form"
          src={src}
          className="h-full w-full border-0"
          allow="fullscreen"
        />
      )}
    </div>
  );
}
